import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Observable, catchError, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HttpService {

  header = {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    'x-loader' : 'true',
  }

  constructor(
    private http:HttpClient,
  ) { }


  get(url:string, noLoader:boolean = false, sendCredentials:boolean = false){
    if(noLoader){
      this.header['x-loader'] = 'false';
    }    return this.http.get(environment.apiBaseUrl+url, {headers: this.header, withCredentials: sendCredentials}).pipe(
      catchError((err:HttpErrorResponse): Observable<any> => {
        return throwError(() => err);
      })
    )
  }

  getBlob(url:string, noLoader:boolean = false, sendCredentials:boolean = false){
    const headers = {
      'Accept': 'application/json',
      'x-loader': noLoader ? 'false' : 'true',
    };

    return this.http.get(environment.apiBaseUrl+url, {headers, withCredentials: sendCredentials, responseType: 'blob'}).pipe(
      catchError((err:HttpErrorResponse): Observable<any> => {
        return throwError(() => err);
      })
    )
  }

  post(url:string, data:any, noLoader:boolean = false, sendCredentials:boolean = false){
    if(noLoader){
      this.header['x-loader'] = 'false';
    }
    
    return this.http.post(environment.apiBaseUrl+url, data, {headers:this.header, withCredentials: sendCredentials}).pipe(
      catchError((err:HttpErrorResponse): Observable<any> => {
        return throwError(() => err);
      })
    )
  }

  postForm(url: string, data: FormData, noLoader: boolean = false, sendCredentials: boolean = false) {
    const headers = {
      'Accept': 'application/json',
      'x-loader': noLoader ? 'false' : 'true',
    };

    return this.http.post(environment.apiBaseUrl + url, data, { headers, withCredentials: sendCredentials }).pipe(
      catchError((err: HttpErrorResponse): Observable<any> => {
        return throwError(() => err);
      }),
    );
  }

  put(url:string, data:any, noLoader:boolean = false, sendCredentials:boolean = false){
    if(noLoader){
      this.header['x-loader'] = 'false';
    }
    return this.http.put(environment.apiBaseUrl+url, data, {headers:this.header, withCredentials: sendCredentials}).pipe(
      catchError((err:HttpErrorResponse): Observable<any> => {
        return throwError(() => err);
      })
    )
  }

  putForm(url:string, data:FormData, noLoader:boolean = false, sendCredentials:boolean = false){
    const headers = {
      'Accept': 'application/json',
      'x-loader': noLoader ? 'false' : 'true',
    };

    return this.http.put(environment.apiBaseUrl+url, data, {headers, withCredentials: sendCredentials}).pipe(
      catchError((err:HttpErrorResponse): Observable<any> => {
        return throwError(() => err);
      })
    )
  }

  patch(url:string, data:any, noLoader:boolean = false, sendCredentials:boolean = false){
    if(noLoader){
      this.header['x-loader'] = 'false';
    }
    return this.http.patch(environment.apiBaseUrl+url, data, {headers:this.header, withCredentials: sendCredentials}).pipe(
      catchError((err:HttpErrorResponse): Observable<any> => {
        return throwError(() => err);
      })
    )
  }

  delete(url:string, noLoader:boolean = false, sendCredentials:boolean = false){
    if(noLoader){
      this.header['x-loader'] = 'false';
    }
    return this.http.delete(environment.apiBaseUrl+url, {headers:this.header, withCredentials: sendCredentials}).pipe(
      catchError((err:HttpErrorResponse): Observable<any> => {
        return throwError(() => err);
      })
    )
  }
}
